module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-2-16620c20e16ead247059e6fc0290a14c.svg";